export default __webpack_public_path__ + "static/media/CHENNAI-2.e78890a4.webp";